module.exports = __webpack_public_path__ + "img/inu_detail.adf0bc48.jpg";